import { mergeHotelAndCheckinPlaceholders, resolvePlaceholderTokenValueForLang } from '../../functions';

/** Clave en settings.placeholders: entity property + code terms-and-conditions */
const PROPERTY_TERMS_AND_CONDITIONS_PH = 'PROPERTY-TERMS-AND-CONDITIONS';

/**
 * Texto de términos y condiciones desde [[PROPERTY-TERMS-AND-CONDITIONS]].
 * Valor esperado: { "__main__": { "es-ES": "...", "en-US": "..." } } (o __MAIN__ si la API normaliza).
 */
export const getPropertyTermsAndConditionsPlaceholderText = (language, hotelPlaceholders, checkInPlaceholders) => {
    const merged = mergeHotelAndCheckinPlaceholders(hotelPlaceholders, checkInPlaceholders);
    const raw = merged[PROPERTY_TERMS_AND_CONDITIONS_PH];
    if (raw == null) {
        return '';
    }
    const text = resolvePlaceholderTokenValueForLang(raw, language);
    return text?.trim() ? text : '';
};
